// the info for versante depends on the codice fiscale of contribuente
const infoVersanti = {
    "07237600965": {  // Paramount
        "codice_fiscale": "CRRLRT82P29D325K",
        "tipo_versante": "1",
        "cognome": "Carrozzo",
        "nome": "Alberto Cosimo",
        "sesso": "M",
        "data_di_nascita": "29091982",
        "comune_nascita": "Dolo",
        "provincia_nascita": "VE",
        "iban": "IT49Q0310401608000000821427"
    },
    "06447960961": {  // Studio Tributario Societario
        "codice_fiscale": "MRCLCU65D29F205T",
        "tipo_versante": "1",
        "cognome": "Mercaldo",
        "nome": "Luca",
        "sesso": "M",
        "data_di_nascita": "29041965",
        "comune_nascita": "Milano",
        "provincia_nascita": "MI",
        "iban": "IT26S0623009503000063525287"
    },
    "13152200963": {  // Snegaro Limited
        "codice_fiscale": "RDNDTR74D11Z135F",
        "tipo_versante": "1",
        "cognome": "Rodin",
        "nome": "Dimitri",
        "sesso": "M",
        "data_di_nascita": "11041974",
        "comune_nascita": "Urss",
        "provincia_nascita": "EE",
        "iban": "IT57A0318501600000010301240"
    },
    "13282530966": {  // Forever H
        "codice_fiscale": "SSSJPL76T50Z133N",
        "tipo_versante": "1",
        "cognome": "Sassu",
        "nome": "Jane Paule",
        "sesso": "F",
        "data_di_nascita": "10121976",
        "comune_nascita": "Svizzera",
        "provincia_nascita": "EE",
        "iban": "IT51R0200801628000107095347"
    },
    "03802730154": {  // UMI
        "codice_fiscale": "DMRDNL66E16F205A",
        "tipo_versante": "1",
        "cognome": "Demartini",
        "nome": "Daniele",
        "sesso": "M",
        "data_di_nascita": "16051966",
        "comune_nascita": "Milano",
        "provincia_nascita": "MI",
        "iban": "IT89F0356601600000125116019"
    },
    "09542840963": {  // MATHYS ORTOPEDIA SRL
        "codice_fiscale": "GRSGRG70M03F205Z",
        "tipo_versante": "1",
        "cognome": "GRASSI",
        "nome": "GIORGIO",
        "sesso": "M",
        "data_di_nascita": "03081970",
        "comune_nascita": "Milano",
        "provincia_nascita": "MI",
        "iban": "IT76V0100501605000000007358"
    },
    "02099150381": {  // FLO - FELLONI LATERAL OFFICE STP S.R.L.
        "codice_fiscale": "FLLDVD91L26C814O",
        "tipo_versante": "1",
        "cognome": "FELLONI",
        "nome": "DAVIDE",
        "sesso": "M",
        "data_di_nascita": "26071991",
        "comune_nascita": "Codigoro",
        "provincia_nascita": "FE",
        "iban": "IT46N0538713003000003468872"
    },
    "10517560156": {  // LINK ITALIA SPA
        "codice_fiscale": "MVLNRC67A27E514F",
        "tipo_versante": "1",
        "cognome": "MOVILIA",
        "nome": "ENRICO",
        "sesso": "M",
        "data_di_nascita": "27011967",
        "comune_nascita": "LEGNANO",
        "provincia_nascita": "MI",
        "iban": "IT87X0503401739000000018222"
    },
    "12233020960": {  // CROPE SRLS
        "codice_fiscale": "CIOSMN95E05A479C",
        "tipo_versante": "1",
        "cognome": "CIOE",
        "nome": "SIMONE",
        "sesso": "M",
        "data_di_nascita": "05051995",
        "comune_nascita": "ASTI",
        "provincia_nascita": "AT",
        "iban": "IT30J0200801633000106391067"
    },
    "13695230964": {  // Clothes Agency Italy srl
        "codice_fiscale": "FRTLCU85C28G888A",
        "tipo_versante": "1",
        "cognome": "Fortugna",
        "nome": "Luca",
        "sesso": "M",
        "data_di_nascita": "28031985",
        "comune_nascita": "Pordenone",
        "provincia_nascita": "PN",
        "iban": "IT45Y0569601600000028741X62"
    },
    "11038850159": {  // Luigi Di Troia
        "codice_fiscale": "DTRLGU42P03F205U",
        "tipo_versante": "1",
        "cognome": "Di Troia",
        "nome": "Luigi",
        "sesso": "M",
        "data_di_nascita": "03091942",
        "comune_nascita": "Milano",
        "provincia_nascita": "MI",
        "iban": "IT18C0306933010100000003758"
    }
}


// get all info except for conto iban
export const VERSANTE = Object.fromEntries(
    Object.entries(infoVersanti).map(([k, v]) => [k, Object.fromEntries(Object.entries(v).filter(([k2, _]) => k2 !== 'iban'))])
);


// get iban info for each versante
export const CONTO_IBAN = Object.fromEntries(
    Object.entries(infoVersanti).map(([k, v]) => [k, v['iban']])
);
